module.exports = __webpack_public_path__ + "111515bc.png";